import * as React from "react";
import { DialogTitle } from "@material-ui/core";
import './ConfirmModal.scss'

export interface IModalConfirmModalTitlePros {
    label: string   
}

export const ConfirmModalTitle:React.FC<IModalConfirmModalTitlePros> = (props) => { 
    return (
        <DialogTitle>
        {props.label}
      </DialogTitle>  
    )
}


// WEBPACK FOOTER //
// ./src/component/shared/confirm-modal/ConfirmModalTitle.tsx